export default __webpack_public_path__ + "static/media/flag-poland.b04013b1.svg";